import { timezones } from '@ipfabric/utils/timezones';
import type { CronEveryOption } from './cronTypes';

export const timezoneOptions = timezones.map((tz) => ({
  value: tz,
  label: tz,
}));

export const everyOptions: Array<{ value: CronEveryOption; label: string }> = [
  { value: 'year', label: 'Year' },
  { value: 'month', label: 'Month' },
  { value: 'week', label: 'Week' },
  { value: 'day', label: 'Day' },
  { value: 'hour', label: 'Hour' },
  { value: 'custom', label: 'Custom' },
];

export const everyOptionValues = everyOptions.map(
  (option) => option.value,
) as readonly CronEveryOption[];

export const monthOptions = [
  { value: '1', label: 'January' },
  { value: '2', label: 'February' },
  { value: '3', label: 'March' },
  { value: '4', label: 'April' },
  { value: '5', label: 'May' },
  { value: '6', label: 'June' },
  { value: '7', label: 'July' },
  { value: '8', label: 'August' },
  { value: '9', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

export const dayOptions = Array.from({ length: 31 }, (_value, index) => {
  const day = String(index + 1);
  return { value: day, label: day };
});

export const weekDayOptions = [
  { value: '1', label: 'Monday' },
  { value: '2', label: 'Tuesday' },
  { value: '3', label: 'Wednesday' },
  { value: '4', label: 'Thursday' },
  { value: '5', label: 'Friday' },
  { value: '6', label: 'Saturday' },
  { value: '0', label: 'Sunday' },
];

/**
 * Field width constants for custom cron input fields
 */
export const FIELD_WIDTH_THRESHOLD = 3;
export const FIELD_WIDTH_WIDE = 'w-16';
export const FIELD_WIDTH_NARROW = 'w-8';
